import { defaultFlushContext, flushUpdates, registerFlushListener, requestFlush, } from '../state/context';
import { reportRuntimeError } from '../state/diagnostics';
export function createPatchScheduler(options) {
    const lane = options.lane ?? 'dom';
    const now = options.now ?? (() => Date.now());
    const schedule = options.schedule ?? queueMicrotask;
    const flushContext = options.flushContext ?? defaultFlushContext;
    let commitId = 0;
    let disposed = false;
    let pending = [];
    const flush = () => {
        if (disposed || pending.length === 0) {
            return;
        }
        commitId += 1;
        const batch = pending;
        pending = [];
        const meta = {
            lane,
            commitId,
            time: now(),
        };
        try {
            options.sink(batch, meta);
        }
        catch (error) {
            reportRuntimeError('flush-listener', error);
        }
    };
    const unregisterFlushListener = registerFlushListener(flush, flushContext);
    return {
        enqueue(patches) {
            if (disposed || patches.length === 0) {
                return;
            }
            pending.push(...patches);
            requestFlush(schedule, flushContext);
        },
        flushSync() {
            flushUpdates(flushContext);
            flush();
        },
        dispose() {
            disposed = true;
            pending.length = 0;
            unregisterFlushListener();
        },
    };
}
//# sourceMappingURL=scheduler.js.map